import _ from 'lodash'
import { Vue, Component, Prop, Provide } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

@Component
export class BaseForm<T> extends Vue {
  @Provide('formName') public formName = 'default'
  @Provide('destroyOnUnmount') public destroyOnUnmount = true
  @Provide('destroyOnMount') public destroyOnMount = true

  @Action('components/updateSnackbar')
  public updateSnackbar!: (data: {
    txt: string
    type: 'success' | 'error',
  }) => void

  @Getter('form/getByName')
  public getByName!: (name: string) => any

  public created() {
    if (this.destroyOnMount) {
      this.$store.dispatch('form/reset', this.formName)
    }
  }

  public destroyed() {
    if (this.destroyOnUnmount) {
      this.$store.dispatch('form/reset', this.formName)
    }
  }

  get form(): T {
    return this.getByName(this.formName)
  }

  public doConvertStringToInt(data: any) {
    _.forEach(data, (value, key) => {
      if (typeof value === 'object') {
        this.doConvertStringToInt(value)
      }
      const regExp = new RegExp(/^[0-9]+$/)
      const exceptKey = [
        'id',
        'mobile',
        'phone',
        'cid',
        'date',
        'time',
        'address',
        'zipcode',
        'postcode',
        'geocode',
      ]
      const found = _.find(exceptKey, (word) => _.includes(_.lowerCase(key), word))
      if ((regExp.test(value) && !found) || (value === '-1' && !found)) {
        data[key] = parseInt(value, 10)
      }
    })
    delete data.fields
    return data
  }

  public doConvertIntToString(data: any) {
    if (data) {
      _.forEach(data, (value, key) => {
        if (typeof value === 'object') {
          this.doConvertIntToString(value)
        }
        const regExp = new RegExp(/^[0-9]+$/)
        const exceptKey = [
          'id',
          'mobile',
          'phone',
          'cid',
          'date',
          'time',
          'address',
          'zipcode',
          'postcode',
          'geocode',
          'price',
          'pay',
        ]
        const found = _.find(exceptKey, (word) => _.includes(_.lowerCase(key), word))
        if ((regExp.test(value) && !found) || (value === -1 && !found)) {
          data[key] = _.toString(value)
        }
      })
      delete data.fields
      return data
    }
  }

  public onSubmit(data: any) {
    this.$emit('submit', data)
  }

  public async validate(submitFunc: (arg0: any) => void, transformFunc?: (arg0: any) => void) {
    return new Promise<void>(async (resolve, reject) => {
      const isValid = await (this.$refs.form as any).validate()
      if (isValid) {
        if (transformFunc) {
          submitFunc(transformFunc(this.getByName(this.formName)))
          return resolve()
        } else {
          submitFunc(this.getByName(this.formName))
          return resolve()
        }
      }
      this.updateSnackbar({txt: 'กรุณากรอกข้อมูลให้ถูกต้อง', type: 'error'})
      return resolve()
    })
  }
}
